"use strict";

var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var Router        = require("react-router");
import { browserHistory } from 'react-router';
var AuthActions   = require("../../actions/AuthenticationActions");
var AuthStore     = require("../../stores/AuthenticationStore");
var ErrorModal = require("./ErrorModal.react");
var LoginSidebar = require("./LoginSidebar.react");
var Input = require("react-bootstrap").Input;
var Button = require("react-bootstrap").Button;
var Modal = require("react-bootstrap").Modal;
var clone = require("clone");

var LoginPage = React.createClass({
    getInitialState: function() {
        var newState = AuthStore.getState();
        newState.isErrorOpen = false;
        return newState;
    },
    componentDidMount: function()  {
        AuthStore.listen(this.onChange);
        var token = localStorage.getItem("token");
        if (token && token.length > 0) {
            browserHistory.push("/inventory");
        }
    },
    componentWillUnmount() {
        AuthStore.unlisten(this.onChange);
    },
    onChange: function() {
        var authState = AuthStore.getState();
        var token = authState.token;
        var showError = false;
        if(authState.login_error || authState.signup_error) {
          showError = true;
        }

        this.setState({ 'login_error': authState.login_error, 'loading': authState.loading, 'signup_error': authState.signup_error, 'isErrorOpen': showError });
        if (token !== "") {
            browserHistory.push("/inventory");
        }
    },
    login: function (email, password) {
        var userData = {
            "username": email,
            "password": password
        };
        AuthActions.loginUser(userData);
    },
    signUp: function (name, email, password, company) {
        var userData = {
            "name": name,
            "email": email,
            "password": password,
            "company_name": company
        };
        AuthActions.signUp(userData);
    },
    show: function() {
        this.setState({
            isErrorOpen: true
        });
    },
    hide: function() {
        this.setState({
            isErrorOpen: false
        });
    },
    render: function() {
      var errorText = "";
      if(this.state.signup_error) {
        errorText = "Nýskráning tókst ekki, vinsamlegast athugaðu hvort allt sé rétt útfyllt.";
      }
      if(this.state.login_error) {
        errorText = "Tölvupóstfang eða lykilorð vitlaust innslegið. Vinsamlegast reyndu aftur.";
      }
      return (
          <div className="Login">
              <ErrorModal show={this.state.isErrorOpen} hide={this.hide} message={errorText} />
              <LoginSidebar login={this.login} loading={this.state.loading} signUp={this.signUp} signUpError={this.state.signup_error}/>
          </div>
      );
    }
});

module.exports = LoginPage;



// WEBPACK FOOTER //
// ./app/scripts/ui/Login/Login.react.js